import { Link } from 'react-router-dom';

const entries = [
  {
    icon: 'ri-newspaper-line',
    title: '娱乐新闻',
    desc: '追踪娱乐圈最新动态与重磅事件',
    to: '/news',
    tone: 'bg-primary-100 text-primary-700',
  },
  {
    icon: 'ri-film-line',
    title: '影视推荐',
    desc: '精选电影、电视剧与综艺佳作',
    to: '/movies',
    tone: 'bg-accent-100 text-accent-700',
  },
  {
    icon: 'ri-fire-line',
    title: '热门话题',
    desc: '聚焦时下讨论度最高的娱乐话题',
    to: '/hot-topics',
    tone: 'bg-secondary-100 text-secondary-800',
  },
];

export default function QuickEntries() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-10 md:px-8 md:py-12">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        {entries.map((e) => (
          <Link
            key={e.to}
            to={e.to}
            className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 hover:bg-primary-50/40"
          >
            <span className={`flex h-14 w-14 flex-none items-center justify-center rounded-lg text-2xl ${e.tone}`}>
              <i className={e.icon} />
            </span>
            <div className="min-w-0 flex-1">
              <h3 className="font-heading text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
                {e.title}
              </h3>
              <p className="mt-1 text-xs text-foreground-500">{e.desc}</p>
            </div>
            <i className="ri-arrow-right-line text-xl text-foreground-400 transition-colors group-hover:text-primary-500" />
          </Link>
        ))}
      </div>
    </section>
  );
}